import React from "react";

import {
    Chip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    useTheme,
} from "@mui/material";
import SubCard from "components/common/card/SubCard";
import HeadComponent from "../list/list-head/Head.component";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

const GatwayTable = ({
    item,
}) => {
    const { t } = useTranslation()
    const theme = useTheme();

    const TABLE_HEAD = useMemo(() => (
        [
            { id: "gateway", label: "Gateway", alignRight: false, order: true },
            { id: "gatewayID", label: "ID", alignRight: false, order: true },
            { id: "gatewayAddress", label: t('Address'), alignRight: false, order: true },
            { id: "gatewayAddressInternal", label: t('Internal address'), alignRight: false, order: true },
            { id: "gatewayMAC", label: "MAC", alignRight: false, order: true },
            { id: "gatewaySerial", label: t('Serial'), alignRight: false, order: true },
        ]
    ), [t])

    return (
        <TableContainer>
            <SubCard
                sx={{
                    bgcolor: theme.palette.mode === "dark" ? "dark.800" : "grey.50",
                    mb: 2,
                }}
                content={false}
            >
                <Table size="small" aria-label="purchases">
                    <HeadComponent header={TABLE_HEAD} sx={{ fontSize: 12 }} />

                    <TableBody>
                        <TableRow
                            sx={{
                                "&:last-child td, &:last-child th": {
                                    border: 0,
                                },
                            }}
                        >
                            <TableCell align="left">
                                {item?.gateway ? (
                                    <Chip
                                        label={t('Present')}
                                        size='small'
                                        sx={{
                                            backgroundColor: "#B9F6CA",
                                            color: "#00C853",
                                        }}
                                    />
                                ) : (
                                    <Chip label={t('absent')} size='small' />
                                )}
                            </TableCell>

                            {!!item?.gatewayID && (
                                <TableCell align="left">{item?.gatewayID}</TableCell>
                            )}

                            {!!item?.gatewayAddress && (
                                <TableCell align="left">{item?.gatewayAddress}</TableCell>
                            )}
                            {!!item?.gatewayAddressInternal && (
                                <TableCell align="left">{item?.gatewayAddressInternal}</TableCell>
                            )}
                            {!!item?.gatewayMAC && (
                                <TableCell align="left">{item?.gatewayMAC}</TableCell>
                            )}
                            {!!item?.gatewaySerial && (
                                <TableCell align="left">{item?.gatewaySerial}</TableCell>
                            )}
                        </TableRow>
                    </TableBody>
                </Table>
            </SubCard>
        </TableContainer>
    );
};

export default GatwayTable;


